import { readApiBase } from './config'
import {
  attachClientMeta,
  attachJsonAccept,
  attachRequestId,
  attachSaToken,
  attachUserPublicId,
  logResponseInDev,
} from './defaultInterceptors'
import {
  type ErrorInterceptor,
  HttpClient,
  type RequestInterceptor,
  type ResponseInterceptor,
} from './httpClient'

export { ApiError, isApiError } from './errors'
export type {
  ErrorInterceptor,
  ErrorInterceptorContext,
  RequestInterceptor,
  RequestInterceptorContext,
  ResponseInterceptor,
  ResponseInterceptorContext,
} from './httpClient'
export type { ApiEnvelope } from '@glyphic/shared-core'

function normalizeBase(): string {
  return readApiBase().replace(/\/+$/, '')
}

const http = new HttpClient({ getBaseUrl: normalizeBase })

http
  .useRequest(attachJsonAccept)
  .useRequest(attachClientMeta)
  .useRequest(attachSaToken)
  .useRequest(attachUserPublicId)
  .useRequest(attachRequestId)
  .useResponse(logResponseInDev)

/** 可注册额外拦截器，或在外层 `useError` 做全局 Toast 等 */
export const apiHttp: HttpClient = http

export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  return http.request<T>(path, init)
}

export function registerRequestInterceptor(interceptor: RequestInterceptor): void {
  http.useRequest(interceptor)
}

export function registerResponseInterceptor(
  interceptor: ResponseInterceptor,
): void {
  http.useResponse(interceptor)
}

export function registerErrorInterceptor(interceptor: ErrorInterceptor): void {
  http.useError(interceptor)
}
